module.exports = __webpack_public_path__ + "PR.png?a206df0fad61e25b3f1da2ac55d878be";